import { render, staticRenderFns } from "./ChooseHostMode.vue?vue&type=template&id=ef5fb25c&"
import script from "./ChooseHostMode.vue?vue&type=script&lang=js&"
export * from "./ChooseHostMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports